import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { WinRT } from '@lenovo/tan-client-bridge-le';

@Component({
	selector: 'vtr-ui-button',
	templateUrl: './ui-button.component.html',
	styleUrls: ['./ui-button.component.scss']
})
export class UiButtonComponent implements OnInit, AfterViewInit, OnChanges {
	@Input() ariaLabel = '';
	@Input() label: string;
	@Input() isFullWidth: boolean;
	@Input() isHalfWidth: boolean;
	@Input() vtrMetricEnabled: any;
	@Input() alreadyJoinGroup = 'unjoined';
	@Input() upperCaseLabel = true;
	@Input() capitalizeLabel = false;
	@Output() onClick = new EventEmitter<any>();

	// Use the tooltipText variable to receive a personalized text
	@Input() tooltipText: string;
	@Input() tooltip = true;
	@Input() isDisabled = false;
	@Input() isRegular = false;
	@Input() btnHeight = false;
	@Input() isGradient = false;
	@Input() buttonColor: string;
	@Input() title: string;
	@Input() linkId: any;
	@Input() routerPath: string;
	@Input() href: string;
	@Input() inRedBackground = false;
	@Input() inBluelightBackground = false;
	@Input() tabIndex = 0; // please use this one if you need special tabindex.
	@Input() isLoading = false;
	@Input() autoFocus = false;
	TIME_OUT = 200;
	groupNone = 'groupNone';
	constructor() { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.autoFocus) {
			if (changes.autoFocus && changes.autoFocus.currentValue === true) {
				setTimeout(() => {
					document.getElementById(this.linkId).focus();
				}, this.TIME_OUT);

			}

		}
	}

	ngAfterViewInit(): void {
		if (this.autoFocus) {
			setTimeout(() => {
				document.getElementById(this.linkId).focus();
			}, this.TIME_OUT);

		}
	}

	initTooltipText() {
		// If the tooltipText is not defined, use the label text in it
		if (!this.tooltipText) {
			this.tooltipText = this.label;
		}
	}

	onClickButton(event) {
		window.getSelection().empty();
		if (this.href) {
			WinRT.launchUri(this.href);
			return;
		}
		this.onClick.emit(event);
	}

	getButtonColor(buttonColor) {
		if (!buttonColor) { return; }
		return `btn-${buttonColor}`;
	}

	ngOnInit() {
		this.initTooltipText();
	}
}
